import ProductType from "./ProductType"
import ProductCategory from "./ProductCategory"
import ProductClassification from "./ProductClassification"
import BaseModel from "./BaseModel";
import Document from "./Document";
import DocumentAttachment from "./DocumentAttachment";

export default class Product extends BaseModel {

	static entity = 'products';
	static route = 'products';
	static plural = 'products';
	static singular = 'product';

	static fields () {
		return {
			id: this.attr(null),
			product_type_id: this.attr(null),
			product_type: this.belongsTo(ProductType, 'product_type_id'),
			product_category_id: this.attr(null),
			product_category: this.belongsTo(ProductCategory, 'product_category_id'),
			product_classification_id: this.attr(null),
			product_classification: this.belongsTo(ProductClassification, 'product_classification_id'),
			number: this.attr(null),
			name: this.attr(null),
			stack_size: this.attr(null),
			core_width: this.attr(null),
			width: this.attr(null),
			height: this.attr(null),
			length: this.attr(null),
			density: this.attr(null),
			icon: this.attr(null),
			position: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			images: this.hasManyThrough(Document, DocumentAttachment, 'model_id', 'id', 'id', 'document_id'),
			specifications: this.hasManyThrough(Document, DocumentAttachment, 'model_id', 'id', 'id', 'document_id'),
		}
	}

	static parseFilteredName(name) {
		return Product.decodeHTMLEntities(name);
	}

	getFilteredName() {
		return Product.parseFilteredName(this.name);
	}

	getImages() {
		let images = [];
		this.images.forEach(document => {
			if(document.ref === 'image') {
				images.push(document);
			}
		})
		return images;
	}

	getSpecifications() {
		let specifications = [];
		this.specifications.forEach(document => {
			if(document.ref === 'specification') {
				specifications.push(document);
			}
		})
		return specifications;
	}

	getPrimaryImage() {
		let images = this.getImages();
		return images && images.length ? images[0] : null;
	}

	getPrimarySpecification() {
		let specifications = this.getSpecifications();
		return specifications && specifications.length ? specifications[0] : null;
	}

	static handleBeforeTransform(data) {
		if(data && data.length) {
			data.forEach((row) => {
				if(row.images && row.images.length) {
					row.images.forEach((document) => {
						DocumentAttachment.insert({data: {
							document_id: document.id,
							model_type: 'Product',
							model_id: row.id,
							ref: 'image'
						}});
						//Document.update({where: document.id, data: {ref: 'image'}});
					});
				}
				if(row.specifications && row.specifications.length) {
					row.specifications.forEach((document) => {
						DocumentAttachment.insert({data: {
							document_id: document.id,
							model_type: 'Product',
							model_id: row.id,
							ref: 'specification'
						}});
						//Document.update({where: document.id, data: {ref: 'specification'}});
					});
				}
			});
		}
		return data;
	}

	static configureApi() {
		let config = super.configureApi();
		return config;
	}

	static apiConfig = this.configureApi();

}
